import type { SignupReferenceId } from '~/types/signup-references'

export const SignupReferenceMiscId: SignupReferenceId = 12 as SignupReferenceId
export const SignupReferenceUnknownId: SignupReferenceId = 1 as SignupReferenceId

export const SignupReferenceNewspaperCategory = 'newspaper'
export const SignupReferenceOrganisationCategory = 'organisation'
export const SignupReferenceThirdPartySocialMediaCategory = 'social-media-third-party'

export const SignupReferenceCategories = [
  SignupReferenceNewspaperCategory,
  SignupReferenceOrganisationCategory,
  SignupReferenceThirdPartySocialMediaCategory
]
